import * as React from "react";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import ImageListItemBar from "@mui/material/ImageListItemBar";

export default function TitlebarBelowImageList() {
  return (
    <ImageList
      className="ImageList-style"
      sx={{ width: 1000, height: 2000 }}
      cols={4}
      gap={30}
    >
      {itemData.map((item) => (
        <ImageListItem key={item.img}>
          <img
            srcSet={`${item.img}?w=248&fit=crop&auto=format&dpr=2 2x`}
            src={`${item.img}?w=248&fit=crop&auto=format`}
            alt={item.title}
            loading="lazy"
          />
          <ImageListItemBar title={item.title} position="below" />
        </ImageListItem>
      ))}
    </ImageList>
  );
}

const itemData = [
  {
    img: "https://i.imgur.com/gv00saz.jpeg",
    title: "6Singles",
  },
  {
    img: "https://i.imgur.com/AVmBK3K.jpeg",
    title: "64 BITs",
  },
  {
    img: "https://i.imgur.com/YBpEIBn.jpeg",
    title: "2109",
  },
  {
    img: "https://i.imgur.com/RfLE3mL.jpeg",
    title: "ABANG AI",
  },
  {
    img: "https://i.imgur.com/oVYf1PH.jpeg",
    title: "AI Sigmas",
  },
  {
    img: "https://i.imgur.com/6MyQOCW.jpeg",
    title: "aI.bert",
  },
  {
    img: "https://i.imgur.com/YGRWcFW.jpeg",
    title: "AI4Mobility",
  },
  {
    img: "https://i.imgur.com/Q806W4x.jpeg",
    title: "AIronauts",
  },
  {
    img: "https://i.imgur.com/KZMqtba.jpeg",
    title: "AIVENGERS",
  },
  {
    img: "https://i.imgur.com/hz2KwfI.jpeg",
    title: "AIvolution",
  },
  {
    img: "https://i.imgur.com/vDh6VRz.jpeg",
    title: "AIgnite",
  },
  {
    img: "https://i.imgur.com/tlkfIxg.jpeg",
    title: "AMALGAMATE",
  },
  {
    img: "https://i.imgur.com/fCoecKs.jpeg",
    title: "AO DAI ALGO",
  },
  {
    img: "https://i.imgur.com/SWUlNr1.jpeg",
    title: "Archaeologist",
  },
  {
    img: "https://i.imgur.com/7lzJoKl.jpeg",
    title: "AskCodey",
  },
  {
    img: "https://i.imgur.com/pPMZgAG.jpeg",
    title: "AskNGO",
  },
  {
    img: "https://i.imgur.com/sUMy8UR.jpeg",
    title: "AVA",
  },
  {
    img: "https://i.imgur.com/Lnphxxl.jpeg",
    title: "bAInarybabes",
  },
  {
    img: "https://i.imgur.com/mxXIsxa.jpeg",
    title: "Best of SP",
  },
  {
    img: "https://i.imgur.com/PrAc6xS.jpeg",
    title: "BrainWaves",
  },
  {
    img: "https://i.imgur.com/yQkYscK.jpeg",
    title: "Brightside",
  },
  {
    img: "https://i.imgur.com/ZHgPoWb.jpeg",
    title: "Burning twice a week",
  },
  {
    img: "https://i.imgur.com/6p0pJUN.jpeg",
    title: "Bytecare",
  },
  {
    img: "https://i.imgur.com/1Ni1KbW.jpeg",
    title: "chAmpIon",
  },
  {
    img: "https://i.imgur.com/XIjGw3C.jpeg",
    title: "CheeCheongFun",
  },
  {
    img: "https://i.imgur.com/BSE5yPd.jpeg",
    title: "Chill guys",
  },
  {
    img: "https://i.imgur.com/gyYjY8r.jpeg",
    title: "Chillovators",
  },
  {
    img: "https://i.imgur.com/xzcYcsu.jpeg",
    title: "Cloud Chasers",
  },
  {
    img: "https://i.imgur.com/fTeKvHc.jpeg",
    title: "cmt bois",
  },
  {
    img: "https://i.imgur.com/1qIa62Y.jpeg",
    title: "Coffee Break",
  },
  {
    img: "https://i.imgur.com/mnRO9c0.jpeg",
    title: "CrashCourse",
  },
  {
    img: "https://i.imgur.com/fEXgzJS.jpeg",
    title: "CuraLinkAI",
  },
  {
    img: "https://i.imgur.com/V8YNZpy.jpeg",
    title: "dAIgnostics",
  },
  {
    img: "https://i.imgur.com/5RiGEHo.jpeg",
    title: "Deep Fried Learning",
  },
  {
    img: "https://i.imgur.com/WECOQ16.jpeg",
    title: "DgenAIBT",
  },
  {
    img: "https://i.imgur.com/OdhUUMt.jpeg",
    title: "DrugWise",
  },
  {
    img: "https://i.imgur.com/mHOIcCV.jpeg",
    title: "Engingers",
  },
  {
    img: "https://i.imgur.com/cLQVhJk.jpeg",
    title: "Evalumate Partners",
  },
  {
    img: "https://i.imgur.com/tKE5R89.jpeg",
    title: "Fantastic (101)2",
  },
  {
    img: "https://i.imgur.com/aS7RH0y.jpeg",
    title: "Farmer",
  },
  {
    img: "https://i.imgur.com/gy482ox.jpeg",
    title: "FatCat",
  },
  {
    img: "https://i.imgur.com/kAz2WBd.jpeg",
    title: "FREETHINKERS",
  },
  {
    img: "https://i.imgur.com/jBQ2m0Y.jpeg",
    title: "Gen2TheFuture",
  },
  {
    img: "https://i.imgur.com/gONWmDG.jpeg",
    title: "Genesys",
  },
  {
    img: "https://i.imgur.com/y6aABmN.jpeg",
    title: "GENIE",
  },
  {
    img: "https://i.imgur.com/nT6YWrI.jpeg",
    title: "GoldenPower",
  },
  {
    img: "https://i.imgur.com/7KM8bGR.jpeg",
    title: "GuruGang",
  },
  {
    img: "https://i.imgur.com/6JZbnVb.jpeg",
    title: "GURUSAMA",
  },
  {
    img: "https://i.imgur.com/OOFzbkI.jpeg",
    title: "Hawkathon",
  },
  {
    img: "https://i.imgur.com/5886w0H.jpeg",
    title: "Hustle Squad",
  },
  {
    img: "https://i.imgur.com/uM1mIFk.jpeg",
    title: "HyperGen",
  },
  {
    img: "https://i.imgur.com/LB39jjZ.jpeg",
    title: "IdeaForge",
  },
  {
    img: "https://i.imgur.com/Vd7VJ0M.jpeg",
    title: "Imagine Being Last",
  },
  {
    img: "https://i.imgur.com/0pNidKf.jpeg",
    title: "IRLLabs",
  },
  {
    img: "https://i.imgur.com/XEZc5IS.jpeg",
    title: "JDeum",
  },
  {
    img: "https://i.imgur.com/vXoXKdZ.jpeg",
    title: "Jiaye",
  },
  {
    img: "https://i.imgur.com/WDYF1Of.jpeg",
    title: "Kopi Koders",
  },
  {
    img: "https://i.imgur.com/XUzUEq4.jpeg",
    title: "Lambdai",
  },
  {
    img: "https://i.imgur.com/nh0erIZ.jpeg",
    title: "LeNeural Nexus",
  },
  {
    img: "https://i.imgur.com/8j9bagM.jpeg",
    title: "LightSeek",
  },
  {
    img: "https://i.imgur.com/OJt94ie.jpeg",
    title: "Lumina",
  },
  {
    img: "https://i.imgur.com/scO3c2j.jpeg",
    title: "max tokens excee",
  },
  {
    img: "https://i.imgur.com/Nmns5RH.jpeg",
    title: "MyCampus",
  },
  {
    img: "https://i.imgur.com/yylNitd.jpeg",
    title: "Neural Narrative",
  },
  {
    img: "https://i.imgur.com/D0AerNF.jpeg",
    title: "NidKappers",
  },
  {
    img: "https://i.imgur.com/wyqPOEs.jpeg",
    title: "OnlyUps",
  },
  {
    img: "https://i.imgur.com/8dt4NwM.jpeg",
    title: "pepe",
  },
  {
    img: "https://i.imgur.com/hqc7k5o.jpeg",
    title: "Phobos",
  },
  {
    img: "https://i.imgur.com/z2MJF06.jpeg",
    title: "Pixel",
  },
  {
    img: "https://i.imgur.com/MbHTTBu.jpeg",
    title: "Potatobot",
  },
  {
    img: "https://i.imgur.com/USfBhxG.jpeg",
    title: "Rainbow Dragon",
  },
  {
    img: "https://i.imgur.com/mp6BDm4.jpeg",
    title: "Resona",
  },
  {
    img: "https://i.imgur.com/LLCOunv.jpeg",
    title: "RITZC",
  },
  {
    img: "https://i.imgur.com/dUYRpOH.jpeg",
    title: "RUSH A",
  },
  {
    img: "https://i.imgur.com/MieVAro.jpeg",
    title: "SamurAI",
  },
  {
    img: "https://i.imgur.com/hBThJos.jpeg",
    title: "slackoverflow",
  },
  {
    img: "https://i.imgur.com/evsQbnC.jpeg",
    title: "Spoil Market",
  },
  {
    img: "https://i.imgur.com/6H5SH2Y.jpeg",
    title: "Stockholmies",
  },
  {
    img: "https://i.imgur.com/2NyAnyy.jpeg",
    title: "Sunshine, Rainbow, White Pony",
  },
  {
    img: "https://i.imgur.com/PT0DIho.jpeg",
    title: "Super AI",
  },
  {
    img: "https://i.imgur.com/L99BH6s.jpeg",
    title: "Team 5",
  },
  {
    img: "https://i.imgur.com/zxtBBMw.jpeg",
    title: "Team Optimistic",
  },
  {
    img: "https://i.imgur.com/rT5XDKV.jpeg",
    title: "Team Team",
  },
  {
    img: "https://i.imgur.com/pXyuQoC.jpeg",
    title: "Teletubbies",
  },
  {
    img: "https://i.imgur.com/mFk7lqJ.jpeg",
    title: "The Cornballs",
  },
  {
    img: "https://i.imgur.com/CfiJReY.jpeg",
    title: "The Idea Factory",
  },
  {
    img: "https://i.imgur.com/XyoPcVJ.jpeg",
    title: "The Algorithmically Challenged",
  },
  {
    img: "https://i.imgur.com/jJnnxqF.jpeg",
    title: "ThriveBites",
  },
  {
    img: "https://i.imgur.com/l6RefJ4.jpeg",
    title: "TokenFlow",
  },
  {
    img: "https://i.imgur.com/9oM4TBU.jpeg",
    title: "Trufflethon",
  },
  {
    img: "https://i.imgur.com/JfLzHVu.jpeg",
    title: "Vastamania",
  },
  {
    img: "https://i.imgur.com/OiKP1C3.jpeg",
    title: "Virtuals.tech",
  },
  {
    img: "https://i.imgur.com/kXTcME1.jpeg",
    title: "YipeeYipeeYipee",
  },
  {
    img: "https://i.imgur.com/plaNb2a.jpeg",
    title: "Zennah",
  },
  {
    img: "https://i.imgur.com/tMzUbip.jpeg",
    title: "Zoolingua",
  },
  {
    img: "https://i.imgur.com/ZvF8A6i.jpeg",
    title: "&TEAM",
  },
];
